import { useAuth, useLogout } from "context/AuthProvider";

import { Button } from "@mui/joy";
import { SignOutIcon } from "components/ui/icons";
import { useWindowDimensions } from "hooks";

function Header() {
  const { isMobileWidth } = useWindowDimensions();
  const logout = useLogout();
  const { authUser } = useAuth();

  return (
    <div className="flex flex-row p-3 px-6 ">
      <div className="mr-auto flex flex-row">
        {`${authUser?.displayName}`}
        <div className="font-light text-md">{!isMobileWidth && `(${authUser?.email})`}</div>
      </div>
      <Button color="neutral" variant="outlined" onClick={logout} startDecorator={<SignOutIcon />}>
        {isMobileWidth ? null : "Log Out"}
      </Button>
    </div>
  );
}

export { Header };
